import React, { useEffect, useState } from 'react'

import ChatData from 'services/chatApi'

import { Chat, ChatMessageBox, ChatMessageItem } from 'component-library/chat'
import { Icon } from 'component-library/icon/icon.component'

import * as S from './styles'

import whatsBtn from '../../../static/images/png/whats-button.png'
import data from './data'

interface IFooterInfo {
  message: string
  link: string
}

const WhatsDoubts = () => {
  const [chatData, setChatData] = useState(null) as any
  const footerData = data.chatInfo.footer

  const [isChatActive, setIsChatActive] = useState(false)
  const [isFooterActive, setIsFooterActive] = useState(false)
  const [footerInfo, setFooterInfo] = useState<IFooterInfo>({
    message: footerData.defaultLabel,
    link: '#'
  })
  const [chatMessageItemSelectedIndex, setChatMessageItemSelectedIndex] =
    useState(-1)

  useEffect(() => {
    async function get() {
      const data = await ChatData()
      setChatData(data)
    }
    get()
  }, [])

  const handleChat = () => {
    setIsChatActive(!isChatActive)
  }

  const handleFooter = (item: any) => {
    setFooterInfo({
      message: item.message,
      link: item.link
    })

    setIsFooterActive(true)
  }

  return (
    <>
      <S.Wrapper visible={isChatActive}>
        {isChatActive && (
          <Chat
            closeIconElement={
              <Icon
                name="close"
                color="#7c8195"
                handleClick={() => handleChat()}
              />
            }
            content={
              <>
                <ChatMessageBox
                  headerComposition={chatData.header.map(
                    (item: any, index: any) => (
                      <ChatMessageItem
                        key={`chat-message-item-header-${index}`}
                        type="header"
                        label={item.message}
                        isActive={false}
                      />
                    )
                  )}
                  messagesComposition={chatData.options.map(
                    (item: any, index: number) => (
                      <ChatMessageItem
                        key={`chat-message-item-option-${index}`}
                        type="option"
                        label={item.message}
                        isActive={chatMessageItemSelectedIndex === index}
                        handleClick={() => {
                          handleFooter(item)
                          setChatMessageItemSelectedIndex(index)
                        }}
                      />
                    )
                  )}
                />

                {isFooterActive && (
                  <S.ChatFooterContainer>
                    <span>{footerInfo.message}</span>

                    <Icon
                      name="sendChatFill"
                      color="#df1d3d"
                      size={48}
                      handleClick={() => window.open(footerInfo.link, '_blank')}
                    />
                  </S.ChatFooterContainer>
                )}
              </>
            }
          />
        )}

        {!isChatActive && (
          <S.WhatsappImage
            src={whatsBtn}
            alt="Botão do Whatsapp"
            onClick={() => handleChat()}
          />
        )}
      </S.Wrapper>
    </>
  )
}

export default WhatsDoubts
